<template>
    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            <table class="mx-auto text-center" style="width:100%;">
                <colgroup>
                    <col style="width: 33.33%;">
                    <col style="width: 33.33%;">
                    <col style="width: 33.33%;">
                </colgroup>
                <thead>
                    <tr style="border-bottom: 3px solid #635bff;">
                        <th class="py-3" style="vertical-align: middle;">Sector</th>
                        <th style="vertical-align: middle;">Text</th>
                        <th style="vertical-align: middle;">Holding horizon</th>
                    </tr>
                </thead>
                <tbody class="text-center" style="overflow: auto;">
                    <tr v-for="(project, index) in recos" :key="index" style="border-bottom: 1px solid #635bff;">
                        <td class="py-3 px-2" style="vertical-align: middle;">
                            <select
                                class="form-control-4"
                                v-model="project.sector"
                                :disabled="project.id != null">
                                <option v-for="sector in sects" :key="sector.id" :value="sector.id" >{{ sector.name }}</option>
                            </select>
                            <input type="hidden"
                                :name="'form[' + index + '][sector]'"
                                :value="project.sector ">
                        </td>
                        <td class="py-3 px-2" style="vertical-align: middle;">
                            <textarea
                                class="form-control-5"
                                v-model="project.explanation"
                                style="width: 100%;"
                                cols="50"
                                rows="7">
                            </textarea>
                            <input type="hidden"
                            :name="'form[' + index + '][explanation]'"
                            :value="project.explanation ">
                        </td>
                        <td class="px-2" style="vertical-align: middle;">
                            <input
                                class="form-control-5"
                                v-model="project.time_horizon"
                                style="width: 50%;">
                            <input type="hidden"
                            :name="'form[' + index + '][time_horizon]'"
                            :value="project.time_horizon ">
                        </td>
                    </tr>
                </tbody>
            </table>

         <div class="col-md-12 mx-auto text-center px-0 my-3">
            <button type="button" class="btn-home-main" v-on:click="addRaw">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                Add a security
            </button>
            <button type="submit" class="btn-home-main triggerspinner">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-check-circle mr-2" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                </svg>Submit
            </button>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'sectors',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                sects: [],
                recos: [],
            }
        },

        mounted() {
            this.sectors.forEach(sector =>
            {
                this.sects.push(sector);
            });
        },

        methods: {

            addRaw(){
                this.recos.push(
                {
                    id: null,
                    sector:  this.sects[0],
                    explanation: null,
                    time_horizon: null,
                });            }
        }
    }

</script>